import React from 'react';
import _ from 'lodash';
import { Flex } from 'components/base/layout-components';
import Text from 'components/base/Text';
import { OAuthProviders } from 'common/utils/assets.utils';
import SearchInput from 'components/SearchInput';
import { getColor } from 'common/constants/_colors';

const RepositoriesModalHeader = ({ sensor_name, title, subtitle, setTerm }) => {
  return (
    <Flex
      justify='space-between'
      items='center'
      pb='medium'
      pt='medium'
      borderBottom={`1px solid ${getColor('catskillWhite')}`}
    >
      <Flex direction='column'>
        <Flex direction='row' pb='medium' items='center' content='center'>
          <img
            src={_.get(OAuthProviders[sensor_name.toLowerCase()], 'logo')}
            alt=''
          />
          <Text size='x-x-large' pl='1rem' weight='400'>
            {title}
          </Text>
        </Flex>
        {subtitle}
      </Flex>
      <Flex height='100%'>
        <Flex height='3rem' self='flex-end'>
          <SearchInput
            placeholder='Search repository'
            onChange={term => setTerm(term)}
          />
        </Flex>
      </Flex>
    </Flex>
  );
};

export default RepositoriesModalHeader;
